import React from 'react';
import { View } from 'react-native';

import { useDsEnabled } from '../contexts/DesignSystem';
import ThemedText from './ThemedText';

interface InlineErrorProps {
  message: string | null;
  visible?: boolean;
  testID?: string;
}

export const InlineError: React.FC<InlineErrorProps> = ({ message, visible = true, testID }) => {
  const dsEnabled = useDsEnabled();

  if (!message || !visible) {
    return null;
  }

  return (
    <View
      className={
        dsEnabled
          ? 'mb-ds-16 rounded-ds-md bg-status-error-surface px-ds-16 py-ds-12'
          : 'bg-login-red-10 rounded-lg p-3 px-9 mt-2 mb-4'
      }
      testID={testID}
    >
      <ThemedText type='bodySmall' color='error' className='text-center'>
        {message}
      </ThemedText>
    </View>
  );
};
